import SearchHighlight from "components/SearchHighlight";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { TreeNode } from "utils/tree";
import { SpaceWithParentAccessLevel } from "views/Account/Spaces/types";

import { SpacesListContext } from "../Context";

const SpacesListIdCell = ({
  item: node,
  ...cellProps
}: TableSimpleCellProps<TreeNode<SpaceWithParentAccessLevel>>) => {
  const { searchQuery } = useTypedContext(SpacesListContext);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>
        {searchQuery ? <SearchHighlight fullText={node.id} searchQuery={searchQuery} /> : node.id}
      </TableCellText>
    </TableSimpleCell>
  );
};

export default SpacesListIdCell;
